import React from 'react';

const Header = (props) => {
  return (
    <div className="calendar-header">
      <div className="prev" onClick={props.prev}> 
        <ion className="ion-chevron-left"/>  
      </div>
      <div className="current">
        {props.month} {props.year}
      </div>
      <div className="next" onClick={props.next}> 
        <ion className="ion-chevron-right"/> 
      </div>
    </div>
  )
}

export default Header